import React, { useEffect, useState, useMemo } from 'react';
import { connect } from 'react-redux';
import axios from 'axios';
import config from '../../config';
import { store } from '../../store';
import { retriggerRequest } from '../../services/api/offline-consult';
import { toast } from 'react-toastify';
import { Button, Modal, ModalBody, ModalHeader, Table ,  ModalFooter} from 'reactstrap';

function ShowPharmacyCommsHistory({ sourceId }) {
    const [responseData, setResponseData] = useState(null);
    const [selectedCommToView, setSelectedCommToView] = useState(null);
    const [commToBeRetriggered, setCommToBeRetriggered] = useState(null);
    const [showRetriggerModal, setShowRetriggerModal] = useState(false);

    useEffect(() => {
        const getOrderStatusDetails = async () => {
            try {
                const state = store.getState();
                const headers = state.user.token ? { authorization: state.user.token } : {};
                const { data } = await axios.get(
                    `${config.pharmacyService}/v2/ops/get-comms-history?sourceId=${sourceId}`,
                    { headers }
                );
                setResponseData(data);
            } catch (err) {
                const msg = err?.response?.data?.message || 'Failed to fetch order status details.';
                alert(msg);
            }
        };

        if (sourceId) getOrderStatusDetails();
    }, [sourceId]);

    const tableData = useMemo(() => {
        if (!responseData?.commsLogs) return [];

        const alreadyExists = selectedCommToView
            ? responseData.commsLogs.some(comm => comm.commsContentId === selectedCommToView.commsContentId)
            : true;

        return alreadyExists
            ? responseData.commsLogs
            : [selectedCommToView, ...responseData.commsLogs];
    }, [responseData, selectedCommToView]);

    const closeRetriggerModal = () => {
        setShowRetriggerModal(false);
        setCommToBeRetriggered(null);
    };

    const getRetriggerRequest = async (eventType) => {
        try {
            const res = await retriggerRequest(sourceId, eventType);
            if (res.message === 'success') {
                toast.success('Retriggered Successfully');
                closeRetriggerModal();
            } else {
                toast.error('Something went wrong');
            }
        } catch (err) {
            console.log(err);
            toast.error('Something went wrong');
        }
    };

    return (
        <div style={{ padding: '2rem', maxWidth: '100%', margin: '0 auto' }}>
            <div style={{
                backgroundColor: '#eaf1f9',
                padding: '1rem',
                textAlign: 'center',
                fontWeight: 'bold',
                fontSize: '1.25rem',
                marginBottom: '1rem'
            }}>
                Comms History | Source ID: {sourceId}
            </div>
            <div style={{display : 'flex'}}>
            <div style={{width : selectedCommToView ? '60%' : '100%', marginRight : '1rem' }}>
                <Table bordered hover responsive>
                    <thead className="table-dark">
                        <tr>
                            <th>Comm Content Id</th>
                            <th>Event</th>
                            <th>User Type</th>
                            <th>Triggered at</th>
                            <th>Channel</th>
                            <th>Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {tableData.map((row, index) => {
                            const isSelected = selectedCommToView?.commsContentId === row.commsContentId;
                            return (
                                <tr
                                    key={index}
                                    style={{
                                        backgroundColor: isSelected ? '#d4edda' : undefined,
                                        fontWeight: isSelected ? 'bold' : undefined,
                                    }}
                                >
                                    <td>{row.commsContentId}</td>
                                    <td>{row.eventType}</td>
                                    <td>{row.userType}</td>
                                    <td>{row.triggeredAt}</td>
                                    <td>{row.channel}</td>
                                    <td>
                                        <div style={{ display: 'flex', justifyContent: 'space-around' }}>
                                            <Button color="primary" style={{marginRight : '0.5rem' }} size="md" onClick={() => setSelectedCommToView(row)}>
                                                View
                                            </Button>
                                            <Button color="danger" size="md" onClick={() => {
                                                setCommToBeRetriggered(row);
                                                setShowRetriggerModal(true);
                                            }}>
                                                Retrigger Comm
                                            </Button>
                                        </div>
                                    </td>
                                </tr>
                            );
                        })}
                    </tbody>
                </Table>
            </div>

            {selectedCommToView && (
                <div
                    style={{
                        border: '1px solid #d1dbe5',
                        borderRadius: '8px',
                        padding: '16px',
                        backgroundColor: '#f8fafd',
                        boxShadow: '0 2px 4px rgba(0, 0, 0, 0.05)',
                        marginBottom: '2rem',
                        width : '40%',
                    }}
                >
                    <div style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        marginBottom: '1rem'
                    }}>
                        <h5>Comm Content - ID: {selectedCommToView.commsContentId}</h5>
                        <Button close onClick={() => setSelectedCommToView(null)} />
                    </div>
                    <div style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        marginBottom: '0.5rem',
                    }}>
                        <strong style={{ color: '#2c3e50' }}>
                            {selectedCommToView.channel === 'email'
                                ? '✉️ Email'
                                : selectedCommToView.channel === 'sms'
                                    ? '💬 SMS'
                                    : '📩 WhatsApp'}
                        </strong>
                        <span style={{ color: '#6c757d' }}>{selectedCommToView.timestamp}</span>
                    </div>
                    {selectedCommToView.channel === 'email' ? (
                        <iframe
                            title="Email Content"
                            srcDoc={selectedCommToView.emailContent}
                            style={{
                                width: '100%',
                                minHeight: '400px',
                                border: '1px solid #ccc',
                                borderRadius: '8px',
                                backgroundColor: 'white',
                                resize: 'vertical',
                            }}
                        />
                    ) : (
                        <div style={{ whiteSpace: 'pre-wrap', color: '#34495e' }}>
                            {selectedCommToView.channel === 'whatsapp'
                                ? selectedCommToView.whatsappContent
                                : selectedCommToView.smsContent}
                        </div>
                    )}
                </div>
            )}
            </div>

            <Modal
                isOpen={showRetriggerModal}
            // toggle={this.toggleRetriggerModal}
            >
                <ModalHeader>Retrigger Communication</ModalHeader>
                <ModalBody>
                    Are you sure you want to retrigger the communication?
                </ModalBody>
                <ModalFooter
                    style={{
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'space-around',
                    }}
                >
                    <Button
                        style={{
                            backgroundColor: 'rgb(113, 79, 255)',
                            width: '40%',
                            borderColor: 'rgb(113, 79, 255)',
                            height: '44px',
                        }}
                        onClick={() => getRetriggerRequest(commToBeRetriggered.eventType)}
                    >
                        Retrigger
                    </Button>
                    <Button
                        style={{
                            backgroundColor: 'rgb(255, 255, 255)',
                            width: '40%',
                            borderColor: 'rgb(113, 79, 255)',
                            color: 'rgb(113, 79, 255)',
                            height: '44px',
                        }}
                        onClick={closeRetriggerModal}
                    >
                        Cancel
                    </Button>
                </ModalFooter>
            </Modal>

        </div>
    );
}

const mapStateToProps = (state) => ({
    authToken: state.user.authToken,
    user: state.user,
});

export default connect(mapStateToProps)(ShowPharmacyCommsHistory);
